<div class=" flex flex-col justify-between bg-background-primary p-4 rounded-md shadow-md">
    <div class="flex items-center justify-center">
        <!-- Components -->
        <h1 class="font-semibold">{{header}}</h1>
    </div>
    <!-- Components -->
    <div class="flex justify-center items-center py-10 px-4 my-5 bg-background-secondary rounded-md">
        <h1>{{body}}</h1>
    </div>

    <div class="flex justify-center items-center space-x-4">
        <button class="btn-secondary-md" *ngIf="noText" (click)="onNoClick()">{{noText}}
        </button>
        <button class="btn-primary-md" (click)="onOkClick()">{{yesText}}
        </button>
    </div>
</div>